import registrationActions from './registrationActions'
import installersStatusActions from './installersStatusActions'
import tenantActions from './tenantActions'
import checklistItemActions from './checklistItemActions'

const actions = {
  ...registrationActions,
  ...installersStatusActions,
  ...tenantActions,
  ...checklistItemActions
}

export default actions